import {
  DocumentStatus,
  DocumentVerificationStatus,
  type SendingRequestBundle,
} from '@domain/types';

import type { TerminalImportStatus } from './uploadStatus';

export type { TerminalImportStatus };

export function resolveTerminalImportStatus(
  bundle: SendingRequestBundle,
): TerminalImportStatus | undefined {
  if (bundle.document.status !== DocumentStatus.Suspended) {
    return undefined;
  }

  if (bundle.document.verificationStatus === DocumentVerificationStatus.Downgraded) {
    return 'ANALYZE_UNAVAILABLE';
  }

  if (
    bundle.document.verificationStatus === DocumentVerificationStatus.ReadyToSend ||
    bundle.document.verificationStatus === DocumentVerificationStatus.UserVerificationNeeded
  ) {
    return 'TERMINATED';
  }

  return undefined;
}
